import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackAllFeaturesClick } from './tracking';
import { Specifications } from '../../components/Specifications';
import { SpecificationsPopup } from '../../components/SpecificationsPopup';
import { SpecificationsPopupContent } from '../../components/SpecificationsPopup/components/SpecificationsPopupContent';
import { SpecificationsSeoTable } from '../../components/SpecificationsSeoTable';
import {
  getSpecifications,
  getDisplayName,
  getDetailedSpecifications,
  getHousesByTurn,
} from '../../selectors/newbuilding';

export function SpecificationsContainer() {
  const [isOpen, setOpened] = React.useState(false);
  const open = React.useCallback(() => {
    setOpened(true);
    trackAllFeaturesClick();
  }, [setOpened]);
  const close = React.useCallback(() => setOpened(false), [setOpened]);

  const specifications = useSelector(getSpecifications);
  const displayName = useSelector(getDisplayName);
  const detailedSpecifications = useSelector(getDetailedSpecifications);
  const housesByTurn = useSelector(getHousesByTurn);

  return (
    <>
      <SpecificationsSeoTable specifications={specifications} />
      <Specifications specifications={specifications} onClick={open} />
      {(detailedSpecifications || housesByTurn.length > 0) && (
        <SpecificationsPopup open={isOpen} onClose={close}>
          <SpecificationsPopupContent
            newbuildingName={displayName}
            specifications={detailedSpecifications}
            housesByTurn={housesByTurn}
          />
        </SpecificationsPopup>
      )}
    </>
  );
}
